import { SET_DISCOUNTED_CASH_FLOW_METHOD } from "./mutations";

import _ from "lodash";

const initialState = {
  data: {
    discountedCFM: {
      startYear: 2023,
      totalYears: 5,
      discountFactor: 0.5,
      yearsArray: _.times(5, _.constant(0)),
      discountFactorArray: _.times(5, _.constant(0)),
      method: 1,
      initialValue: 100,
      freeCashFlow:  _.times(5, _.constant(0)),
      growthPercentage: 3.26,
      EBIT: _.times(5, _.constant(0)),
      tax: 5,
      reinvestment: _.times(5, _.constant(0)),
      dividePresent:  _.times(5, _.constant(0)),
      presentValue:  _.times(5, _.constant(0)),
      terminalYear: {
        finalYearFreeCashFlow: 0,
        longTermGrowthRate: 0,
        forecastedFreeCashFlow: 0,
        divideCapitalizationRate: 0,
        value: 0,
        forecastedFuture: 0,
        dividePresent: 0,
        presentValue: 0,
      },
      valueSubjectCompany: 0,
      delta: 0,
      analystNote: ["", "", "", ""]
    },
  },
  discountedCashFlowMethod: null
};

const discountedCFMReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DISCOUNTED_CASH_FLOW_METHOD: {
      return { ...state, discountedCashFlowMethod: payload };
    }

    default:
      return state;
  }
};

export default discountedCFMReducer;
